import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React, {useEffect, useState} from 'react';
import styles from './CompositionAlert.module.scss';

export interface CompositionAlertProps {
  trigger: boolean;
  title?: string;
  text?: string;
  closeable?: boolean;
  onClick?(): void;
}

const CompositionAlert: React.FC<CompositionAlertProps> = ({
  trigger,
  title,
  text,
  closeable = true,
  onClick,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(trigger);
  }, [trigger]);

  return (
    <>
      {isVisible && (
        <div
          className={`${styles.wrapper} ${onClick ? styles.clickable : ''}`}
          onClick={onClick}
          role="button"
        >
          <span className={styles.iconWrapper}>
            <FontAwesomeIcon icon="exclamation-circle" />
          </span>
          <div>
            {title && <h3 className={styles.title}>{title}</h3>}
            {text && <p className={styles.text}>{text}</p>}
          </div>

          {closeable && (
            <button
              type="button"
              className={styles.closeButton}
              onClick={() => setIsVisible(!isVisible)}
              data-testid="closeButton"
            >
              <FontAwesomeIcon icon="times" />
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default CompositionAlert;
